// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V22H22V2ZM4 8V4H5.53163L8.86496 8H4ZM11.4684 8L8.13504 4H12.5316L15.865 8H11.4684ZM18.4684 8L15.135 4H20V8H18.4684ZM9 14V12H15V14H9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-movie-clapper-filled')
export default class MovieClapperFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'movie-clapper-filled',
    }
  }
}
